import React, { useState } from "react";

const ReadMore = (props) => {
  const { text, styles } = props;
  const [isReadMore, setIsReadMore] = useState(true);
  const showHideDescription = () => {
    setIsReadMore(!isReadMore);
  };

  const showMoreText = (
    <>
      <span
        style={{
          color: "#000",
        }}
      ></span>
      <i className="fas fa-plus"></i> More
    </>
  );
  const showLessText = (
    <>
      {" "}
      <i className="fas fa-minus"></i> Less
    </>
  );

  const textTruncate = (str, length, ending) => {
    if (length === null) {
      length = 100;
    }
    if (ending === null) {
      ending = "...";
    }
    if (str.length > length) {
      str = str.substring(0, length - ending.length);
      str = str.split(" ");
      str.pop();
      str = str.join(" ") + ending;
    }
    return str;
  };

  return (
    <>
      {isReadMore ? textTruncate(text, 330, "...") : text}
      <span onClick={showHideDescription} className={styles.moreBtn}>
        {text &&
          text.length > 330 &&
          (isReadMore ? showMoreText : showLessText)}
      </span>
    </>
  );
};

const ShortDescription = (props) => {
  const { text, styles } = props;
  return (
    <div className={styles.description}>
      <ReadMore styles={styles} text={text}></ReadMore>
    </div>
  );
};

export default ShortDescription;
